export const GET_EMPLOYEE_EXEMPTIONS = 'GET_EMPLOYEE_EXEMPTIONS';
export const GET_EMPLOYEE_EXEMPTIONS_SUCCESS = 'GET_EMPLOYEE_EXEMPTIONS_SUCCESS';

export const SAVE_EMPLOYEE_EXEMPTION = 'SAVE_EMPLOYEE_EXEMPTION';
export const SAVE_EMPLOYEE_EXEMPTION_SUCCESS = 'SAVE_EMPLOYEE_EXEMPTION_SUCCESS';

export const CHANGE_EMPLOYEE_EXEMPTION_STATUS = 'CHANGE_EMPLOYEE_EXEMPTION_STATUS';
export const CHANGE_EMPLOYEE_EXEMPTION_STATUS_SUCCESS = 'CHANGE_EMPLOYEE_EXEMPTION_STATUS_SUCCESS';

export const EMPLOYEE_EXEMPTION_FAILURE = 'EMPLOYEE_EXEMPTION_FAILURE';
